import { Button, Tooltip } from '@orbita-ui/core';
import { CentroCosto } from 'core/centrocosto/models/CentroCosto';
import { COST_CENTRE_EDIT_PATH, COST_CENTRE_MOVE_PATH } from 'core/centrocosto/routes';
import { LIST_CARDS_PATH } from 'core/tarjeta/routes';
import { useNavigate } from 'react-router-dom';
import { TablePlaceholder } from 'shared/placeholders';
import { Table } from 'shared/table';
import { TableComponentParams } from 'shared/table/hoc/withPagination';
import { useImpersonationGuard } from 'auth/hooks/useImpersonationGuard';

export interface CostCentreTableProps extends TableComponentParams<CentroCosto> {
  onDelete?: (centroCosto: CentroCosto) => void;
  showButtons?: boolean;
}

export function CostCentreTable({
  tableContent,
  placeholderRows,
  onDelete,
  showButtons = true,
}: TableComponentParams<CentroCosto> & {
  onDelete?: (value: CentroCosto) => void;
  showButtons?: boolean;
}) {
  const navigate = useNavigate();
  const { guardWriteAction } = useImpersonationGuard();

  return (
    <Table
      thead={
        <tr>
          <th>Denominación</th>
          <th>Cuenta</th>
          <th>Depende de</th>
          {showButtons && <th style={{ width: '1%' }} className="text-nowrap"></th>}
        </tr>
      }
      tbody={
        <>
          {tableContent?.map((item) => {
            const esPrincipal = !item.nombreCentroCostoPadre;

            return (
              <tr key={item.id} data-testid={`centrocosto${item.id}`}>
                <td>{item.nombre}</td>
                <td>{item.numeroCuenta}</td>
                <td>{item.nombreCentroCostoPadre || '-'}</td>

                {showButtons && (
                  <td style={{ width: '1%' }} className="text-nowrap">
                    <div className="flex gap-2">
                      <Tooltip text="Ver tarjetas asociadas" position="left">
                        <Button
                          className="list-button"
                          color="inverted"
                          variant="ghost"
                          icon="PaymentCardIcon"
                          onClick={() =>
                            navigate(
                              `${LIST_CARDS_PATH}?centroCostoAsociadoId=${item.id}`,
                            )
                          }
                        />
                      </Tooltip>

                      <Tooltip text="Modificar" position="left">
                        <Button
                          className="list-button"
                          color="inverted"
                          variant="ghost"
                          icon="EditIcon"
                          onClick={() =>
                            navigate(COST_CENTRE_EDIT_PATH.replace(':id', `${item.id}`))
                          }
                        />
                      </Tooltip>

                      {!esPrincipal && (
                        <>
                          <Tooltip text="Mover" position="left">
                            <Button
                              className="list-button"
                              color="inverted"
                              variant="ghost"
                              icon="SortHorizontalIcon"
                              onClick={() =>
                                navigate(COST_CENTRE_MOVE_PATH.replace(':id', `${item.id}`))
                              }
                            />
                          </Tooltip>

                          <Tooltip text="Eliminar" position="left">
                            <Button
                              color="destructive"
                              variant="filled"
                              icon="DeleteIcon"
                              onClick={() => guardWriteAction(() => onDelete?.(item))}
                            />
                          </Tooltip>
                        </>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            );
          }) || (
            <TablePlaceholder cols={showButtons ? 4 : 3} rows={placeholderRows || 5} />
          )}
        </>
      }
    />
  );
}
